import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Downloading Ditto", -1)
const _hoisted_2 = { class: "dt-instructions__instructions-container" }
const _hoisted_3 = {
  key: "1",
  class: "dt-instructions__instruction-container"
}
const _hoisted_4 = { class: "dt-instructions__instruction" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "dt-instructions__instruction-image",
  src: "/icons/download@2x.png"
}, null, -1)
const _hoisted_6 = { class: "dt-instructions__text-content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "dt-instructions__instruction-title" }, "1. Download", -1)
const _hoisted_8 = { class: "dt-instructions__instruction-description" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Ditto will automatically download. If you don't see the download begin, ")
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" to redownload.")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("article", {
  key: "2",
  class: "dt-instructions__instruction-container"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__instruction" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "dt-instructions__instruction-image",
      src: "/icons/ditto@2x.png"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__text-content" }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "dt-instructions__instruction-title" }, "2. Open"),
      /*#__PURE__*/_createElementVNode("p", { class: "dt-instructions__instruction-description" }, "Locate Ditto in your downloads folder and open it.")
    ])
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("article", {
  key: "3",
  class: "dt-instructions__instruction-container"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__instruction" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "dt-instructions__instruction-image",
      src: "/icons/share@2x.png"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "dt-instructions__text-content" }, [
      /*#__PURE__*/_createElementVNode("h2", { class: "dt-instructions__instruction-title" }, "3. Share"),
      /*#__PURE__*/_createElementVNode("p", { class: "dt-instructions__instruction-description" }, [
        /*#__PURE__*/_createTextVNode("That's it! Press '"),
        /*#__PURE__*/_createElementVNode("strong", null, "Start Sharing"),
        /*#__PURE__*/_createTextVNode("' and your computer screen will appear on the big screen.")
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_TransitionGroup, {
        appear: "",
        name: "fade-up"
      }, {
        default: _withCtx(() => [
          _createElementVNode("article", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("p", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("a", {
                    ref: "link",
                    href: _ctx.downloadPath,
                    download: ""
                  }, "click here", 8, _hoisted_10),
                  _hoisted_11
                ])
              ])
            ])
          ]),
          _hoisted_12,
          _hoisted_13
        ]),
        _: 1
      })
    ])
  ], 64))
}